import { Box } from '@mui/material'
import type { ImgHTMLAttributes } from 'react'

type LogoProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string
}

export default function Logo({ src, style, ...props }: LogoProps) {
  return (
    <Box
      component='span'
      sx={(theme) => ({
        display: 'inline-flex',
        maxWidth: '100%',
        [theme.accessibility.highContrast.mediaQuery('active')]: {
          forcedColorAdjust: 'none',
          backgroundColor: 'CanvasText',
          WebkitMask: `url("${src}") center / contain no-repeat`,
          mask: `url("${src}") center / contain no-repeat`
        }
      })}>
      <Box
        component='img'
        src={src}
        sx={(theme) => ({
          display: 'block',
          maxWidth: '100%',
          [theme.accessibility.highContrast.mediaQuery('active')]: {
            opacity: 0
          }
        })}
        style={style}
        {...props}
      />
    </Box>
  )
}
